import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const DashboardLoadable = loadable(() => import(/* webpackChunkName: "dashboard-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default DashboardLoadable;
